import { FC, SVGProps } from "react";

export const GiftIcon: FC<SVGProps<SVGSVGElement>> = ({
  fill = "white",
  className,
  width = 24,
  height = 24,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={fill}
    fillRule="evenodd"
    clipRule="evenodd"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path d="M9 2a2.5 2.5 0 1 0 0 5a2.5 2.5 0 1 0 0-5zm0 1.5a1 1 0 1 1 0 2a1 1 0 1 1 0-2z" />
    <path d="M15 2a2.5 2.5 0 1 0 0 5a2.5 2.5 0 1 0 0-5zm0 1.5a1 1 0 1 1 0 2a1 1 0 1 1 0-2z" />
    <path d="M2 7h20v4H2zM3.5 8.5v1h17v-1z" />
    <path d="M3.5 9.5h17V21h-17zM5 11v8.5h14V11z" />
    <path d="M11.25 7h1.5v14h-1.5z" />
  </svg>
);
